import React, { useCallback } from 'react';
import styled from 'styled-components';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { useServiceCollections } from 'shared/apollo/pageHooks/useAllServiceCollections';
import { SectionServiceCollectionRender } from 'npo/pages/ReportBuilder/Components/ImpactSummary/SectionServiceCollection';
import { AnswerInput, HelperText } from 'shared/providers/ProgramProvider';

interface ProgramServiceCollectionFieldProps {
  sectionKey: string | null | undefined;
  questionId: number;
  value: AnswerInput;
  onChange: (next: AnswerInput) => void;
  disabled?: boolean;
}

const StyledDiv = styled.div`
  .service-collection-textfield {
    background-color: ${COLORS.whiteBase};
  }
`;

const ProgramServiceCollectionField: React.FC<ProgramServiceCollectionFieldProps> = ({
  sectionKey,
  questionId,
  value,
  disabled,
  onChange,
}) => {
  const state = useServiceCollections({});

  const handleChange = useCallback(
    (_questionId: number, next: string) => {
      onChange({ ...value, text: next, questionText: next });
    },
    [onChange, value],
  );

  if (state.type === 'REQUEST_INIT' || state.type === 'REQUEST_START') {
    return <TrueImpactLoading />;
  }

  if (state.type === 'REQUEST_ERROR') {
    return (
      <TrueImpactText variant="body-small" color="critical">
        {state.error?.message || 'Failed to load service collections.'}
      </TrueImpactText>
    );
  }

  if (state.data.length === 0) {
    return (
      <TrueImpactText color="critical" variant="body-small">
        No service collections are available yet.
      </TrueImpactText>
    );
  }

  return (
    <StyledDiv>
      <HelperText sectionKey={sectionKey} questionId={questionId} />
      <SectionServiceCollectionRender
        data={state.data}
        onChange={handleChange}
        questionId={questionId}
        guidanceText={undefined}
        value={value.text ?? ''}
        disabled={disabled}
      />
    </StyledDiv>
  );
};

export default ProgramServiceCollectionField;
